// Chrome拡張機能のエラーを抑制するためのユーティリティ
export const suppressChromeExtensionErrors = () => {
    // Chrome拡張機能の "message port closed" エラーを抑制
    const originalError = console.error;
    console.error = (...args) => {
        const message = args.join(' ');
        // Chrome拡張機能関連のエラーをフィルタリング
        const suppressedPatterns = [
            /The message port closed before a response was received/,
            /Extension context invalidated/,
            /Could not establish connection/,
            /chrome-extension:/,
            /moz-extension:/,
            /safari-extension:/,
            /Unchecked runtime\.lastError/,
            /runtime\.lastError/
        ];
        const shouldSuppress = suppressedPatterns.some(pattern => pattern.test(message));
        if (!shouldSuppress) {
            originalError.apply(console, args);
        }
    };
    // console.warn も同様に処理
    const originalWarn = console.warn;
    console.warn = (...args) => {
        const message = args.join(' ');
        const suppressedPatterns = [
            /The message port closed before a response was received/,
            /Extension context invalidated/,
            /chrome-extension:/,
            /runtime\.lastError/
        ];
        const shouldSuppress = suppressedPatterns.some(pattern => pattern.test(message));
        if (!shouldSuppress) {
            originalWarn.apply(console, args);
        }
    };
    // runtime.lastError の警告を抑制
    if (typeof window !== 'undefined' && window.chrome && window.chrome.runtime) {
        const originalAddListener = window.chrome.runtime.onMessage?.addListener;
        if (originalAddListener) {
            window.chrome.runtime.onMessage.addListener = function (listener) {
                const wrappedListener = (message, sender, sendResponse) => {
                    try {
                        return listener(message, sender, sendResponse);
                    }
                    catch (error) {
                        // Chrome拡張機能のエラーを静かに処理
                        if (window.chrome?.runtime?.lastError) {
                            // lastErrorを読み取ってクリア
                            const lastError = window.chrome.runtime.lastError;
                            console.debug('Chrome extension error suppressed:', lastError.message);
                        }
                        return false;
                    }
                };
                return originalAddListener.call(this, wrappedListener);
            };
        }
    }
};
export const initializeErrorSuppression = () => {
    // ページロード時にエラー抑制を初期化
    if (typeof window !== 'undefined') {
        suppressChromeExtensionErrors();
        // 未処理のPromise拒否をキャッチ
        window.addEventListener('unhandledrejection', (event) => {
            const message = event.reason?.message || event.reason;
            // Chrome拡張機能関連のエラーを抑制
            if (typeof message === 'string' &&
                (message.includes('message port closed') ||
                    message.includes('Extension context invalidated'))) {
                event.preventDefault();
                console.debug('Chrome extension promise rejection suppressed:', message);
            }
        });
        // グローバルエラーハンドラー
        window.addEventListener('error', (event) => {
            const message = event.message || '';
            const source = event.filename || '';
            // Chrome拡張機能関連のエラーを抑制
            const suppressedPatterns = [
                'chrome-extension',
                'moz-extension',
                'safari-extension',
                'message port closed',
                'runtime.lastError',
                'Extension context invalidated'
            ];
            const shouldSuppress = suppressedPatterns.some(pattern => message.includes(pattern) || source.includes(pattern));
            if (shouldSuppress) {
                event.preventDefault();
                console.debug('Chrome extension error suppressed:', message);
                return true;
            }
        });
        // DOM上のエラーも監視
        document.addEventListener('error', (event) => {
            const target = event.target;
            if (target && target.src && target.src.includes('chrome-extension')) {
                event.preventDefault();
                console.debug('Chrome extension resource error suppressed:', target.src);
            }
        }, true);
    }
};
